.drums {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.segments {
  padding: var(--s4) var(--gutter) 0;
  background: var(--panel);
}

.body {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  padding: var(--s4) var(--gutter) 0;
}

/* Kit */
.kitHead {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--s3);
}

.grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: var(--s2);
  margin-top: var(--s4);
}

.selected {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--s3);
  margin-top: var(--s5);
}

.selectedName {
  font-size: 1.1875rem;
  line-height: 1.2;
  font-weight: 500;
  overflow-wrap: anywhere;
}

.actions {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(0, 1fr);
  gap: var(--s3);
}

/* Groove */
.readouts {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 52px;
  gap: var(--s2);
}

.summary {
  margin-top: var(--s4);
  color: var(--ink2);
}

.barLabel {
  margin: var(--s4) 0 0 var(--lane-w);
  color: var(--ink2);
}

.lanes {
  --lane-w: 3.25rem;
}

.lane {
  display: flex;
  align-items: center;
}

.laneName {
  flex: none;
  overflow: hidden;
  text-overflow: ellipsis;
  width: var(--lane-w);
  font-size: 1rem;
  font-weight: 500;
}

.steps {
  display: flex;
  flex: 1 1 auto;
  gap: 6px;
  min-width: 0;
}

.beat {
  display: flex;
  flex: 1 1 0;
  gap: 2px;
  min-width: 0;
}

/* Library */
.libraryTop {
  position: sticky;
  top: 0;
  z-index: 1;
  background: var(--panel);
  padding-bottom: var(--s2);
}

.chips {
  display: flex;
  gap: var(--s2);
  margin: 0 calc(-1 * var(--gutter));
  padding: 5px var(--gutter);
  overflow-x: auto;
  scrollbar-width: none;
}

.chips::-webkit-scrollbar {
  display: none;
}

/* v0.5.1: the perc kind row under the Perc chip, same chips one size down (DESIGN_SYSTEM Drums › Library) */
.kindChips {
  composes: chips;
  padding-top: 0;
}

.kindChips > button {
  min-height: 32px;
  font-size: 0.875rem;
}

/* The smaller chip still gets a 44 px hit area */
.kindChips > button::after {
  inset: -6px -2px;
}

.libSummary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--s2);
  margin-top: var(--s2);
}

.libSummary p {
  min-width: 0;
  color: var(--ink2);
}

.libActions {
  display: flex;
  flex: none;
  gap: var(--s2);
}

.libBottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--s3);
}

.bulk {
  display: flex;
  flex-wrap: wrap;
  gap: var(--s2);
}

.check {
  display: flex;
  color: var(--slate);
}

.folderLink {
  display: flex;
}

.sheetBody {
  padding: var(--s2) 0 var(--s4);
}

.sheetHead {
  margin: var(--s5) 0 var(--s2);
}

.sheetActions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--s2);
  margin-top: var(--s3);
}

.chipWrap {
  display: flex;
  flex-wrap: wrap;
  gap: var(--s2);
  margin-top: var(--s2);
}

.reasons {
  margin: 0;
  padding-left: 1.25rem;
}

.reasons li + li {
  margin-top: var(--s1);
}

.tagForm {
  display: flex;
  gap: var(--s2);
  margin-top: var(--s2);
}

.tagInput {
  flex: 1 1 auto;
  min-width: 0;
  min-height: var(--target);
  padding: 0 var(--s3);
  border: 1px solid var(--line);
  border-radius: 6px;
  background: var(--pad);
  color: var(--ink);
  font: inherit;
}

.measured {
  margin: 0 0 var(--s5);
}

.measured > div {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--s3);
  padding: var(--s2) 0;
  border-top: 1px solid var(--line);
}

.measured > div:last-child {
  border-bottom: 1px solid var(--line);
}

.measured dt {
  color: var(--ink2);
}

.measured dd {
  margin: 0;
  font-family: var(--font-mono, inherit);
  text-align: right;
}

/* Kit */
.kitName {
  display: inline-flex;
  align-items: center;
  gap: var(--s1);
  min-height: var(--target);
  padding: 0;
  background: none;
  border: 0;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.suggested {
  margin-top: var(--s2);
}

.sheetRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--s3);
  margin-top: var(--s3);
}

.readoutGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--s2);
  margin-top: var(--s3);
}

.tuneResult {
  margin-top: var(--s2);
  color: var(--ink2);
}

/* Groove */
.laneButton {
  min-height: var(--target);
  padding: 0;
  background: none;
  border: 0;
  color: var(--ink);
  font: inherit;
  font-size: 1rem;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
}

/* A lane on the style's synth voice: calm, secondary text, never an error */
.laneSynth {
  color: var(--ink2);
  font-weight: 400;
}

.synthNote {
  margin-top: var(--s3);
}

.sectionRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--s3);
}
